// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import appAlert from './utils/appAlert'

Vue.config.productionTip = false

// 全局提示弹窗（标题「提示」），替代原生 alert()
Vue.prototype.$alert = appAlert

function startApp() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}

// 关键：挂载前确保内嵌子集字体(RSJ Sans)已就绪。
// 否则 mounted 中的 fitCells 首次列宽/缩字测量会因 font-display:swap
// 命中兜底字体，按兜底字体度量计算内联px；待 RSJ Sans 换入后内联px已固定，
// 造成「APK首启」与「已缓存字体的浏览器」字号/列宽不一致。
// 1.5s 超时兜底放行，避免极端情况下白屏。
if (document.fonts && document.fonts.load) {
  const fontReady = document.fonts.load('16px "RSJ Sans"')
    .then(() => document.fonts.ready)
    .catch(() => {})
  const timeout = new Promise(resolve => setTimeout(resolve, 1500))
  Promise.race([fontReady, timeout]).then(startApp)
} else {
  startApp()
}



// WEBPACK FOOTER //
// ./src/main.js